<template>
  <v-app>
    <div id="app">
      <TheHeader/>
      <main class="app-main">
        <Features/>
        <Banner/>
        <InfoForm/>
        <Infos/>
      </main>
    </div>
  </v-app>
</template>
<script>
import Features from "@/components/features.vue";
import Banner from "@/components/banner.vue";
import Header from "@/components/header.vue";
import Infos from "@/components/infos.vue";
import TheHeader from "@/components/header.vue";
import InfoForm from "@/views/info-form/index.vue";
import {EVENTS} from "@/utils/tracker";

export default {
  components: {InfoForm, TheHeader, Infos, Header, Banner, Features},
  mounted() {
    this.$tracker.track(EVENTS.PAGE_IN)
  },
  methods: {}
}
</script>
<style lang="less">
#app {
  margin: 0 auto;
  max-width: 600px;
  width: 100%;
  height: 100%;
  background: #EAEEF2;
  overflow: auto;
}


</style>
